import {ROOT_URL} from '@/store';

export function userDeleteRequest() {
  const ans = fetch(ROOT_URL+'/auth/delete_account/', {
    method: 'GET',
    credentials: 'include',
  }).then(async function(result) {
    if (result.status == 200) {
      window.location.reload();
    };
  });
  return ans;
}
